/* tslint:disable */
/* eslint-disable */
/**
 * ISOCHECK Swagger
 * This is the WebService of ISOCHECK that provides the connection to the Azure Storage Tables.
 *
 * The version of the OpenAPI document: 3.4.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CatAThresholdDTO
 */
export interface CatAThresholdDTO {
    /**
     * 
     * @type {string}
     * @memberof CatAThresholdDTO
     */
    'rowKey': CatAThresholdDTORowKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof CatAThresholdDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof CatAThresholdDTO
     */
    'doubleShell': number;
    /**
     * 
     * @type {number}
     * @memberof CatAThresholdDTO
     */
    'external': number;
    /**
     * 
     * @type {number}
     * @memberof CatAThresholdDTO
     */
    'monolithic': number;
    /**
     * 
     * @type {number}
     * @memberof CatAThresholdDTO
     */
    'height': CatAThresholdDTOHeightEnum;
}

export const CatAThresholdDTORowKeyEnum = {
    _160: '160',
    _170: '170',
    _180: '180',
    _190: '190',
    _200: '200',
    _210: '210',
    _220: '220',
    _230: '230',
    _240: '240',
    _250: '250',
    _260: '260',
    _270: '270',
    _280: '280'
} as const;

export type CatAThresholdDTORowKeyEnum = typeof CatAThresholdDTORowKeyEnum[keyof typeof CatAThresholdDTORowKeyEnum];
export const CatAThresholdDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type CatAThresholdDTOHeightEnum = typeof CatAThresholdDTOHeightEnum[keyof typeof CatAThresholdDTOHeightEnum];

/**
 * 
 * @export
 * @interface CreateErrorReportDto
 */
export interface CreateErrorReportDto {
    /**
     * Description of the error
     * @type {string}
     * @memberof CreateErrorReportDto
     */
    'description': string;
    /**
     * Name of the person reporting the error
     * @type {string}
     * @memberof CreateErrorReportDto
     */
    'name'?: string;
    /**
     * Email of the person reporting the error
     * @type {string}
     * @memberof CreateErrorReportDto
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface DTypeDTO
 */
export interface DTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof DTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof DTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'capacity': DTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof DTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'height': DTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof DTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {string}
     * @memberof DTypeDTO
     */
    'shearForceLoadBearingCapacityCode': string;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'length': DTypeDTOLengthEnum;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'diameterOfThrustBearing': number;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'diameterOfThrustShearNegBearing': number;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'diameterOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof DTypeDTO
     */
    'numberOfThrustShearNegBearing': number;
    /**
     * 
     * @type {string}
     * @memberof DTypeDTO
     */
    'fireProtectionType': DTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DTypeDTO
     */
    'type': DTypeDTOTypeEnum;
}

export const DTypeDTOCapacityEnum = {
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_50: 50,
    NUMBER_70: 70,
    NUMBER_90: 90,
    NUMBER_100: 100
} as const;

export type DTypeDTOCapacityEnum = typeof DTypeDTOCapacityEnum[keyof typeof DTypeDTOCapacityEnum];
export const DTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type DTypeDTOHeightEnum = typeof DTypeDTOHeightEnum[keyof typeof DTypeDTOHeightEnum];
export const DTypeDTOLengthEnum = {
    NUMBER_1000: 1000
} as const;

export type DTypeDTOLengthEnum = typeof DTypeDTOLengthEnum[keyof typeof DTypeDTOLengthEnum];
export const DTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    R90: 'R90'
} as const;

export type DTypeDTOFireProtectionTypeEnum = typeof DTypeDTOFireProtectionTypeEnum[keyof typeof DTypeDTOFireProtectionTypeEnum];
export const DTypeDTOTypeEnum = {
    D: 'D'
} as const;

export type DTypeDTOTypeEnum = typeof DTypeDTOTypeEnum[keyof typeof DTypeDTOTypeEnum];

/**
 * 
 * @export
 * @interface MTypeDTO
 */
export interface MTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof MTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof MTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'capacity': MTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof MTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'height': MTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof MTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {string}
     * @memberof MTypeDTO
     */
    'shearForceLoadBearingCapacityCode': string;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'length': MTypeDTOLengthEnum;
    /**
     * 
     * @type {number}
     * @memberof MTypeDTO
     */
    'numberOfThrustShearNegBearing': number;
    /**
     * 
     * @type {string}
     * @memberof MTypeDTO
     */
    'fireProtectionType': MTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MTypeDTO
     */
    'type': MTypeDTOTypeEnum;
}

export const MTypeDTOCapacityEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80,
    NUMBER_90: 90,
    NUMBER_100: 100,
    NUMBER_110: 110,
    NUMBER_120: 120
} as const;

export type MTypeDTOCapacityEnum = typeof MTypeDTOCapacityEnum[keyof typeof MTypeDTOCapacityEnum];
export const MTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type MTypeDTOHeightEnum = typeof MTypeDTOHeightEnum[keyof typeof MTypeDTOHeightEnum];
export const MTypeDTOLengthEnum = {
    NUMBER_1000: 1000
} as const;

export type MTypeDTOLengthEnum = typeof MTypeDTOLengthEnum[keyof typeof MTypeDTOLengthEnum];
export const MTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    Rei120: 'REI120'
} as const;

export type MTypeDTOFireProtectionTypeEnum = typeof MTypeDTOFireProtectionTypeEnum[keyof typeof MTypeDTOFireProtectionTypeEnum];
export const MTypeDTOTypeEnum = {
    M: 'M'
} as const;

export type MTypeDTOTypeEnum = typeof MTypeDTOTypeEnum[keyof typeof MTypeDTOTypeEnum];

/**
 * @type ProductsControllerGetAllISOCheckProducts200ResponseInner
 * @export
 */
export type ProductsControllerGetAllISOCheckProducts200ResponseInner = DTypeDTO | MTypeDTO | SMVariantDTO | ShearForceTypeDTO | ShortElementTypeDTO | SteelSMTypeDTO | SteelSQTypeDTO | VarHVMTypeDTO | VarUVMTypeDTO | VarWOMTypeDTO | VarWUMTypeDTO;

/**
 * 
 * @export
 * @interface SMVariantDTO
 */
export interface SMVariantDTO {
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'capacity': SMVariantDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof SMVariantDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'height': SMVariantDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'fireProtectionType': SMVariantDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'length': SMVariantDTOLengthEnum;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'numberOfThrustShearNegBearing': number;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'dimensionOfThrustShearPosBearing': string;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof SMVariantDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'type': SMVariantDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'shearForceLoadBearingCapacityCode': string;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'variant': SMVariantDTOVariantEnum;
    /**
     * 
     * @type {string}
     * @memberof SMVariantDTO
     */
    'minimumWallThickness': string;
}

export const SMVariantDTOCapacityEnum = {
    NUMBER_14: 14,
    NUMBER_20: 20
} as const;

export type SMVariantDTOCapacityEnum = typeof SMVariantDTOCapacityEnum[keyof typeof SMVariantDTOCapacityEnum];
export const SMVariantDTOHeightEnum = {
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type SMVariantDTOHeightEnum = typeof SMVariantDTOHeightEnum[keyof typeof SMVariantDTOHeightEnum];
export const SMVariantDTOFireProtectionTypeEnum = {
    R0: 'R0'
} as const;

export type SMVariantDTOFireProtectionTypeEnum = typeof SMVariantDTOFireProtectionTypeEnum[keyof typeof SMVariantDTOFireProtectionTypeEnum];
export const SMVariantDTOLengthEnum = {
    NUMBER_220: 220
} as const;

export type SMVariantDTOLengthEnum = typeof SMVariantDTOLengthEnum[keyof typeof SMVariantDTOLengthEnum];
export const SMVariantDTOTypeEnum = {
    Sm: 'SM'
} as const;

export type SMVariantDTOTypeEnum = typeof SMVariantDTOTypeEnum[keyof typeof SMVariantDTOTypeEnum];
export const SMVariantDTOVariantEnum = {
    Uv: 'UV',
    Wo: 'WO',
    Wu: 'WU'
} as const;

export type SMVariantDTOVariantEnum = typeof SMVariantDTOVariantEnum[keyof typeof SMVariantDTOVariantEnum];

/**
 * 
 * @export
 * @interface ShearForceTypeDTO
 */
export interface ShearForceTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof ShearForceTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof ShearForceTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'capacity': ShearForceTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof ShearForceTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'height': ShearForceTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShearForceTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShearForceTypeDTO
     */
    'fireProtectionType': ShearForceTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShearForceTypeDTO
     */
    'type': ShearForceTypeDTOTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'length': ShearForceTypeDTOLengthEnum;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'diameterOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'numberOfThrustShearNegBearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'diameterOfThrustShearNegBearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShearForceTypeDTO
     */
    'numberOfThrustBearing'?: number;
}

export const ShearForceTypeDTOCapacityEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80,
    NUMBER_90: 90,
    NUMBER_100: 100,
    NUMBER_110: 110,
    NUMBER_120: 120
} as const;

export type ShearForceTypeDTOCapacityEnum = typeof ShearForceTypeDTOCapacityEnum[keyof typeof ShearForceTypeDTOCapacityEnum];
export const ShearForceTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type ShearForceTypeDTOHeightEnum = typeof ShearForceTypeDTOHeightEnum[keyof typeof ShearForceTypeDTOHeightEnum];
export const ShearForceTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    Rei120: 'REI120'
} as const;

export type ShearForceTypeDTOFireProtectionTypeEnum = typeof ShearForceTypeDTOFireProtectionTypeEnum[keyof typeof ShearForceTypeDTOFireProtectionTypeEnum];
export const ShearForceTypeDTOTypeEnum = {
    Q: 'Q',
    Qq: 'QQ',
    Qz: 'QZ'
} as const;

export type ShearForceTypeDTOTypeEnum = typeof ShearForceTypeDTOTypeEnum[keyof typeof ShearForceTypeDTOTypeEnum];
export const ShearForceTypeDTOLengthEnum = {
    NUMBER_1000: 1000
} as const;

export type ShearForceTypeDTOLengthEnum = typeof ShearForceTypeDTOLengthEnum[keyof typeof ShearForceTypeDTOLengthEnum];

/**
 * 
 * @export
 * @interface ShortElementTypeDTO
 */
export interface ShortElementTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof ShortElementTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof ShortElementTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'capacity': ShortElementTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof ShortElementTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'height': ShortElementTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShortElementTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShortElementTypeDTO
     */
    'fireProtectionType': ShortElementTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShortElementTypeDTO
     */
    'type': ShortElementTypeDTOTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'length': ShortElementTypeDTOLengthEnum;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'diameterOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'numberOfThrustShearNegBearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'diameterOfThrustShearNegBearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'numberOfThrustBearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShortElementTypeDTO
     */
    'diameterOfThrustBearing'?: number;
}

export const ShortElementTypeDTOCapacityEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80,
    NUMBER_90: 90,
    NUMBER_100: 100,
    NUMBER_110: 110,
    NUMBER_120: 120
} as const;

export type ShortElementTypeDTOCapacityEnum = typeof ShortElementTypeDTOCapacityEnum[keyof typeof ShortElementTypeDTOCapacityEnum];
export const ShortElementTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type ShortElementTypeDTOHeightEnum = typeof ShortElementTypeDTOHeightEnum[keyof typeof ShortElementTypeDTOHeightEnum];
export const ShortElementTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    R90: 'R90',
    Rei120: 'REI120'
} as const;

export type ShortElementTypeDTOFireProtectionTypeEnum = typeof ShortElementTypeDTOFireProtectionTypeEnum[keyof typeof ShortElementTypeDTOFireProtectionTypeEnum];
export const ShortElementTypeDTOTypeEnum = {
    Qs: 'QS',
    Qqs: 'QQS',
    Qqsz: 'QQSZ',
    Qsz: 'QSZ'
} as const;

export type ShortElementTypeDTOTypeEnum = typeof ShortElementTypeDTOTypeEnum[keyof typeof ShortElementTypeDTOTypeEnum];
export const ShortElementTypeDTOLengthEnum = {
    NUMBER_300: 300,
    NUMBER_400: 400,
    NUMBER_500: 500
} as const;

export type ShortElementTypeDTOLengthEnum = typeof ShortElementTypeDTOLengthEnum[keyof typeof ShortElementTypeDTOLengthEnum];

/**
 * 
 * @export
 * @interface SteelSMTypeDTO
 */
export interface SteelSMTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof SteelSMTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof SteelSMTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'capacity': SteelSMTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof SteelSMTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'height': SteelSMTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof SteelSMTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SteelSMTypeDTO
     */
    'fireProtectionType': SteelSMTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'length': SteelSMTypeDTOLengthEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'numberOfThrustShearNegBearing': number;
    /**
     * 
     * @type {string}
     * @memberof SteelSMTypeDTO
     */
    'dimensionOfThrustShearPosBearing': string;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof SteelSMTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {string}
     * @memberof SteelSMTypeDTO
     */
    'type': SteelSMTypeDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SteelSMTypeDTO
     */
    'shearForceLoadBearingCapacityCode': string;
}

export const SteelSMTypeDTOCapacityEnum = {
    NUMBER_14: 14,
    NUMBER_20: 20
} as const;

export type SteelSMTypeDTOCapacityEnum = typeof SteelSMTypeDTOCapacityEnum[keyof typeof SteelSMTypeDTOCapacityEnum];
export const SteelSMTypeDTOHeightEnum = {
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type SteelSMTypeDTOHeightEnum = typeof SteelSMTypeDTOHeightEnum[keyof typeof SteelSMTypeDTOHeightEnum];
export const SteelSMTypeDTOFireProtectionTypeEnum = {
    R0: 'R0'
} as const;

export type SteelSMTypeDTOFireProtectionTypeEnum = typeof SteelSMTypeDTOFireProtectionTypeEnum[keyof typeof SteelSMTypeDTOFireProtectionTypeEnum];
export const SteelSMTypeDTOLengthEnum = {
    NUMBER_220: 220
} as const;

export type SteelSMTypeDTOLengthEnum = typeof SteelSMTypeDTOLengthEnum[keyof typeof SteelSMTypeDTOLengthEnum];
export const SteelSMTypeDTOTypeEnum = {
    Sm: 'SM'
} as const;

export type SteelSMTypeDTOTypeEnum = typeof SteelSMTypeDTOTypeEnum[keyof typeof SteelSMTypeDTOTypeEnum];

/**
 * 
 * @export
 * @interface SteelSQTypeDTO
 */
export interface SteelSQTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof SteelSQTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof SteelSQTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'capacity': SteelSQTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof SteelSQTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'height': SteelSQTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof SteelSQTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SteelSQTypeDTO
     */
    'fireProtectionType': SteelSQTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'length': SteelSQTypeDTOLengthEnum;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'numberOfThrustShearNegBearing': number;
    /**
     * 
     * @type {string}
     * @memberof SteelSQTypeDTO
     */
    'dimensionOfThrustShearPosBearing': string;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof SteelSQTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {string}
     * @memberof SteelSQTypeDTO
     */
    'type': SteelSQTypeDTOTypeEnum;
}

export const SteelSQTypeDTOCapacityEnum = {
    NUMBER_8: 8,
    NUMBER_10: 10,
    NUMBER_12: 12
} as const;

export type SteelSQTypeDTOCapacityEnum = typeof SteelSQTypeDTOCapacityEnum[keyof typeof SteelSQTypeDTOCapacityEnum];
export const SteelSQTypeDTOHeightEnum = {
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type SteelSQTypeDTOHeightEnum = typeof SteelSQTypeDTOHeightEnum[keyof typeof SteelSQTypeDTOHeightEnum];
export const SteelSQTypeDTOFireProtectionTypeEnum = {
    R0: 'R0'
} as const;

export type SteelSQTypeDTOFireProtectionTypeEnum = typeof SteelSQTypeDTOFireProtectionTypeEnum[keyof typeof SteelSQTypeDTOFireProtectionTypeEnum];
export const SteelSQTypeDTOLengthEnum = {
    NUMBER_220: 220
} as const;

export type SteelSQTypeDTOLengthEnum = typeof SteelSQTypeDTOLengthEnum[keyof typeof SteelSQTypeDTOLengthEnum];
export const SteelSQTypeDTOTypeEnum = {
    Sq: 'SQ'
} as const;

export type SteelSQTypeDTOTypeEnum = typeof SteelSQTypeDTOTypeEnum[keyof typeof SteelSQTypeDTOTypeEnum];

/**
 * 
 * @export
 * @interface UpdateHeatFlowDto
 */
export interface UpdateHeatFlowDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateHeatFlowDto
     */
    'rowKey': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateHeatFlowDto
     */
    'heatFlow': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateHeatFlowDto
     */
    'productType': UpdateHeatFlowDtoProductTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateHeatFlowDto
     */
    'variant'?: string;
}

export const UpdateHeatFlowDtoProductTypeEnum = {
    M: 'M',
    D: 'D',
    Q: 'Q',
    Qq: 'QQ',
    Qz: 'QZ',
    Qs: 'QS',
    Qqs: 'QQS',
    Qsz: 'QSZ',
    Qqsz: 'QQSZ',
    VarHvm: 'VarHVM',
    VarUvm: 'VarUVM',
    VarWom: 'VarWOM',
    VarWum: 'VarWUM',
    Sm: 'SM',
    Sq: 'SQ',
    SmVariant: 'SMVariant'
} as const;

export type UpdateHeatFlowDtoProductTypeEnum = typeof UpdateHeatFlowDtoProductTypeEnum[keyof typeof UpdateHeatFlowDtoProductTypeEnum];

/**
 * 
 * @export
 * @interface VarHVMTypeDTO
 */
export interface VarHVMTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'capacity': VarHVMTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof VarHVMTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'height': VarHVMTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'shearForceLoadBearingCapacityCode': string;
    /**
     * 
     * @type {number}
     * @memberof VarHVMTypeDTO
     */
    'length': VarHVMTypeDTOLengthEnum;
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'type': VarHVMTypeDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'fireProtectionType': VarHVMTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'minimumWallThickness': string;
    /**
     * 
     * @type {string}
     * @memberof VarHVMTypeDTO
     */
    'variant': VarHVMTypeDTOVariantEnum;
}

export const VarHVMTypeDTOCapacityEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40
} as const;

export type VarHVMTypeDTOCapacityEnum = typeof VarHVMTypeDTOCapacityEnum[keyof typeof VarHVMTypeDTOCapacityEnum];
export const VarHVMTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type VarHVMTypeDTOHeightEnum = typeof VarHVMTypeDTOHeightEnum[keyof typeof VarHVMTypeDTOHeightEnum];
export const VarHVMTypeDTOLengthEnum = {
    NUMBER_1000: 1000
} as const;

export type VarHVMTypeDTOLengthEnum = typeof VarHVMTypeDTOLengthEnum[keyof typeof VarHVMTypeDTOLengthEnum];
export const VarHVMTypeDTOTypeEnum = {
    M: 'M'
} as const;

export type VarHVMTypeDTOTypeEnum = typeof VarHVMTypeDTOTypeEnum[keyof typeof VarHVMTypeDTOTypeEnum];
export const VarHVMTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    Rei120: 'REI120'
} as const;

export type VarHVMTypeDTOFireProtectionTypeEnum = typeof VarHVMTypeDTOFireProtectionTypeEnum[keyof typeof VarHVMTypeDTOFireProtectionTypeEnum];
export const VarHVMTypeDTOVariantEnum = {
    Hv: 'HV'
} as const;

export type VarHVMTypeDTOVariantEnum = typeof VarHVMTypeDTOVariantEnum[keyof typeof VarHVMTypeDTOVariantEnum];

/**
 * 
 * @export
 * @interface VarUVMTypeDTO
 */
export interface VarUVMTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof VarUVMTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof VarUVMTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'capacity': VarUVMTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof VarUVMTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'height': VarUVMTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof VarUVMTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {string}
     * @memberof VarUVMTypeDTO
     */
    'shearForceLoadBearingCapacityCode': string;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'length': VarUVMTypeDTOLengthEnum;
    /**
     * 
     * @type {string}
     * @memberof VarUVMTypeDTO
     */
    'type': VarUVMTypeDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VarUVMTypeDTO
     */
    'fireProtectionType': VarUVMTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'minimumWallThickness': number;
    /**
     * 
     * @type {string}
     * @memberof VarUVMTypeDTO
     */
    'variant': VarUVMTypeDTOVariantEnum;
    /**
     * 
     * @type {number}
     * @memberof VarUVMTypeDTO
     */
    'minimumCeilingThicknessHD': number;
}

export const VarUVMTypeDTOCapacityEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40
} as const;

export type VarUVMTypeDTOCapacityEnum = typeof VarUVMTypeDTOCapacityEnum[keyof typeof VarUVMTypeDTOCapacityEnum];
export const VarUVMTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type VarUVMTypeDTOHeightEnum = typeof VarUVMTypeDTOHeightEnum[keyof typeof VarUVMTypeDTOHeightEnum];
export const VarUVMTypeDTOLengthEnum = {
    NUMBER_1000: 1000
} as const;

export type VarUVMTypeDTOLengthEnum = typeof VarUVMTypeDTOLengthEnum[keyof typeof VarUVMTypeDTOLengthEnum];
export const VarUVMTypeDTOTypeEnum = {
    M: 'M'
} as const;

export type VarUVMTypeDTOTypeEnum = typeof VarUVMTypeDTOTypeEnum[keyof typeof VarUVMTypeDTOTypeEnum];
export const VarUVMTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    Rei120: 'REI120'
} as const;

export type VarUVMTypeDTOFireProtectionTypeEnum = typeof VarUVMTypeDTOFireProtectionTypeEnum[keyof typeof VarUVMTypeDTOFireProtectionTypeEnum];
export const VarUVMTypeDTOVariantEnum = {
    Uv: 'UV'
} as const;

export type VarUVMTypeDTOVariantEnum = typeof VarUVMTypeDTOVariantEnum[keyof typeof VarUVMTypeDTOVariantEnum];

/**
 * 
 * @export
 * @interface VarWOMTypeDTO
 */
export interface VarWOMTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'capacity': VarWOMTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof VarWOMTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'height': VarWOMTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'shearForceLoadBearingCapacityCode': string;
    /**
     * 
     * @type {number}
     * @memberof VarWOMTypeDTO
     */
    'length': VarWOMTypeDTOLengthEnum;
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'type': VarWOMTypeDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'fireProtectionType': VarWOMTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'minimumWallThickness': string;
    /**
     * 
     * @type {string}
     * @memberof VarWOMTypeDTO
     */
    'variant': VarWOMTypeDTOVariantEnum;
}

export const VarWOMTypeDTOCapacityEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40
} as const;

export type VarWOMTypeDTOCapacityEnum = typeof VarWOMTypeDTOCapacityEnum[keyof typeof VarWOMTypeDTOCapacityEnum];
export const VarWOMTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type VarWOMTypeDTOHeightEnum = typeof VarWOMTypeDTOHeightEnum[keyof typeof VarWOMTypeDTOHeightEnum];
export const VarWOMTypeDTOLengthEnum = {
    NUMBER_1000: 1000
} as const;

export type VarWOMTypeDTOLengthEnum = typeof VarWOMTypeDTOLengthEnum[keyof typeof VarWOMTypeDTOLengthEnum];
export const VarWOMTypeDTOTypeEnum = {
    M: 'M'
} as const;

export type VarWOMTypeDTOTypeEnum = typeof VarWOMTypeDTOTypeEnum[keyof typeof VarWOMTypeDTOTypeEnum];
export const VarWOMTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    Rei120: 'REI120'
} as const;

export type VarWOMTypeDTOFireProtectionTypeEnum = typeof VarWOMTypeDTOFireProtectionTypeEnum[keyof typeof VarWOMTypeDTOFireProtectionTypeEnum];
export const VarWOMTypeDTOVariantEnum = {
    Wo: 'WO'
} as const;

export type VarWOMTypeDTOVariantEnum = typeof VarWOMTypeDTOVariantEnum[keyof typeof VarWOMTypeDTOVariantEnum];

/**
 * 
 * @export
 * @interface VarWUMTypeDTO
 */
export interface VarWUMTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof VarWUMTypeDTO
     */
    'rowKey': string;
    /**
     * 
     * @type {string}
     * @memberof VarWUMTypeDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'capacity': VarWUMTypeDTOCapacityEnum;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'expansionJointsDistance': number;
    /**
     * 
     * @type {boolean}
     * @memberof VarWUMTypeDTO
     */
    'hasFireProtection': boolean;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'height': VarWUMTypeDTOHeightEnum;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'heatFlow'?: number;
    /**
     * 
     * @type {string}
     * @memberof VarWUMTypeDTO
     */
    'kindOfThrustBearing'?: string;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'diameterOfTensionRod': number;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'numberOfTensionRods': number;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'numberOfThrustBearing': number;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'numberOfThrustShearPosBearing': number;
    /**
     * 
     * @type {string}
     * @memberof VarWUMTypeDTO
     */
    'shearForceLoadBearingCapacityCode': string;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'length': VarWUMTypeDTOLengthEnum;
    /**
     * 
     * @type {string}
     * @memberof VarWUMTypeDTO
     */
    'type': VarWUMTypeDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VarWUMTypeDTO
     */
    'fireProtectionType': VarWUMTypeDTOFireProtectionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof VarWUMTypeDTO
     */
    'minimumWallThickness': number;
    /**
     * 
     * @type {string}
     * @memberof VarWUMTypeDTO
     */
    'variant': VarWUMTypeDTOVariantEnum;
}

export const VarWUMTypeDTOCapacityEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40
} as const;

export type VarWUMTypeDTOCapacityEnum = typeof VarWUMTypeDTOCapacityEnum[keyof typeof VarWUMTypeDTOCapacityEnum];
export const VarWUMTypeDTOHeightEnum = {
    NUMBER_160: 160,
    NUMBER_170: 170,
    NUMBER_180: 180,
    NUMBER_190: 190,
    NUMBER_200: 200,
    NUMBER_210: 210,
    NUMBER_220: 220,
    NUMBER_230: 230,
    NUMBER_240: 240,
    NUMBER_250: 250,
    NUMBER_260: 260,
    NUMBER_270: 270,
    NUMBER_280: 280
} as const;

export type VarWUMTypeDTOHeightEnum = typeof VarWUMTypeDTOHeightEnum[keyof typeof VarWUMTypeDTOHeightEnum];
export const VarWUMTypeDTOLengthEnum = {
    NUMBER_1000: 1000
} as const;

export type VarWUMTypeDTOLengthEnum = typeof VarWUMTypeDTOLengthEnum[keyof typeof VarWUMTypeDTOLengthEnum];
export const VarWUMTypeDTOTypeEnum = {
    M: 'M'
} as const;

export type VarWUMTypeDTOTypeEnum = typeof VarWUMTypeDTOTypeEnum[keyof typeof VarWUMTypeDTOTypeEnum];
export const VarWUMTypeDTOFireProtectionTypeEnum = {
    R0: 'R0',
    Rei120: 'REI120'
} as const;

export type VarWUMTypeDTOFireProtectionTypeEnum = typeof VarWUMTypeDTOFireProtectionTypeEnum[keyof typeof VarWUMTypeDTOFireProtectionTypeEnum];
export const VarWUMTypeDTOVariantEnum = {
    Wu: 'WU'
} as const;

export type VarWUMTypeDTOVariantEnum = typeof VarWUMTypeDTOVariantEnum[keyof typeof VarWUMTypeDTOVariantEnum];

/**
 * 
 * @export
 * @interface WallStructureDTO
 */
export interface WallStructureDTO {
    /**
     * 
     * @type {string}
     * @memberof WallStructureDTO
     */
    'rowKey': WallStructureDTORowKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof WallStructureDTO
     */
    'timestamp': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof WallStructureDTO
     */
    'thicknesses'?: Array<number>;
}

export const WallStructureDTORowKeyEnum = {
    External: 'external',
    DoubleShell: 'doubleShell',
    Monolithic: 'monolithic'
} as const;

export type WallStructureDTORowKeyEnum = typeof WallStructureDTORowKeyEnum[keyof typeof WallStructureDTORowKeyEnum];


/**
 * ErrorReportApi - axios parameter creator
 * @export
 */
export const ErrorReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Report an error
         * @param {CreateErrorReportDto} createErrorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorReportControllerReportError: async (createErrorReportDto: CreateErrorReportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createErrorReportDto' is not null or undefined
            assertParamExists('errorReportControllerReportError', 'createErrorReportDto', createErrorReportDto)
            const localVarPath = `/error-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createErrorReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ErrorReportApi - functional programming interface
 * @export
 */
export const ErrorReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ErrorReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Report an error
         * @param {CreateErrorReportDto} createErrorReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorReportControllerReportError(createErrorReportDto: CreateErrorReportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorReportControllerReportError(createErrorReportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ErrorReportApi - factory interface
 * @export
 */
export const ErrorReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ErrorReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Report an error
         * @param {ErrorReportApiErrorReportControllerReportErrorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorReportControllerReportError(requestParameters: ErrorReportApiErrorReportControllerReportErrorRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.errorReportControllerReportError(requestParameters.createErrorReportDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for errorReportControllerReportError operation in ErrorReportApi.
 * @export
 * @interface ErrorReportApiErrorReportControllerReportErrorRequest
 */
export interface ErrorReportApiErrorReportControllerReportErrorRequest {
    /**
     * 
     * @type {CreateErrorReportDto}
     * @memberof ErrorReportApiErrorReportControllerReportError
     */
    readonly createErrorReportDto: CreateErrorReportDto
}

/**
 * ErrorReportApi - object-oriented interface
 * @export
 * @class ErrorReportApi
 * @extends {BaseAPI}
 */
export class ErrorReportApi extends BaseAPI {
    /**
     * 
     * @summary Report an error
     * @param {ErrorReportApiErrorReportControllerReportErrorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorReportApi
     */
    public errorReportControllerReportError(requestParameters: ErrorReportApiErrorReportControllerReportErrorRequest, options?: AxiosRequestConfig) {
        return ErrorReportApiFp(this.configuration).errorReportControllerReportError(requestParameters.createErrorReportDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GeneralApi - axios parameter creator
 * @export
 */
export const GeneralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} rowKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerLambdaNoResult: async (rowKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rowKey' is not null or undefined
            assertParamExists('generalControllerLambdaNoResult', 'rowKey', rowKey)
            const localVarPath = `/general/lambda/noResult/{rowKey}`
                .replace(`{${"rowKey"}}`, encodeURIComponent(String(rowKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} rowKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerLambdaProduct: async (rowKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rowKey' is not null or undefined
            assertParamExists('generalControllerLambdaProduct', 'rowKey', rowKey)
            const localVarPath = `/general/lambda/{rowKey}`
                .replace(`{${"rowKey"}}`, encodeURIComponent(String(rowKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} rowKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerPrintOutProduct: async (rowKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rowKey' is not null or undefined
            assertParamExists('generalControllerPrintOutProduct', 'rowKey', rowKey)
            const localVarPath = `/general/report/{rowKey}`
                .replace(`{${"rowKey"}}`, encodeURIComponent(String(rowKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} rowKey 
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerSelected: async (rowKey: string, category: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rowKey' is not null or undefined
            assertParamExists('generalControllerSelected', 'rowKey', rowKey)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('generalControllerSelected', 'category', category)
            const localVarPath = `/general/selected/{rowKey}/{category}`
                .replace(`{${"rowKey"}}`, encodeURIComponent(String(rowKey)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerWelcome: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralApi - functional programming interface
 * @export
 */
export const GeneralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} rowKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalControllerLambdaNoResult(rowKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalControllerLambdaNoResult(rowKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} rowKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalControllerLambdaProduct(rowKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalControllerLambdaProduct(rowKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} rowKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalControllerPrintOutProduct(rowKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalControllerPrintOutProduct(rowKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} rowKey 
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalControllerSelected(rowKey: string, category: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalControllerSelected(rowKey, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalControllerWelcome(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalControllerWelcome(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeneralApi - factory interface
 * @export
 */
export const GeneralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralApiGeneralControllerLambdaNoResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerLambdaNoResult(requestParameters: GeneralApiGeneralControllerLambdaNoResultRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generalControllerLambdaNoResult(requestParameters.rowKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiGeneralControllerLambdaProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerLambdaProduct(requestParameters: GeneralApiGeneralControllerLambdaProductRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generalControllerLambdaProduct(requestParameters.rowKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiGeneralControllerPrintOutProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerPrintOutProduct(requestParameters: GeneralApiGeneralControllerPrintOutProductRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generalControllerPrintOutProduct(requestParameters.rowKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiGeneralControllerSelectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerSelected(requestParameters: GeneralApiGeneralControllerSelectedRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generalControllerSelected(requestParameters.rowKey, requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalControllerWelcome(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generalControllerWelcome(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generalControllerLambdaNoResult operation in GeneralApi.
 * @export
 * @interface GeneralApiGeneralControllerLambdaNoResultRequest
 */
export interface GeneralApiGeneralControllerLambdaNoResultRequest {
    /**
     * 
     * @type {string}
     * @memberof GeneralApiGeneralControllerLambdaNoResult
     */
    readonly rowKey: string
}

/**
 * Request parameters for generalControllerLambdaProduct operation in GeneralApi.
 * @export
 * @interface GeneralApiGeneralControllerLambdaProductRequest
 */
export interface GeneralApiGeneralControllerLambdaProductRequest {
    /**
     * 
     * @type {string}
     * @memberof GeneralApiGeneralControllerLambdaProduct
     */
    readonly rowKey: string
}

/**
 * Request parameters for generalControllerPrintOutProduct operation in GeneralApi.
 * @export
 * @interface GeneralApiGeneralControllerPrintOutProductRequest
 */
export interface GeneralApiGeneralControllerPrintOutProductRequest {
    /**
     * 
     * @type {string}
     * @memberof GeneralApiGeneralControllerPrintOutProduct
     */
    readonly rowKey: string
}

/**
 * Request parameters for generalControllerSelected operation in GeneralApi.
 * @export
 * @interface GeneralApiGeneralControllerSelectedRequest
 */
export interface GeneralApiGeneralControllerSelectedRequest {
    /**
     * 
     * @type {string}
     * @memberof GeneralApiGeneralControllerSelected
     */
    readonly rowKey: string

    /**
     * 
     * @type {string}
     * @memberof GeneralApiGeneralControllerSelected
     */
    readonly category: string
}

/**
 * GeneralApi - object-oriented interface
 * @export
 * @class GeneralApi
 * @extends {BaseAPI}
 */
export class GeneralApi extends BaseAPI {
    /**
     * 
     * @param {GeneralApiGeneralControllerLambdaNoResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public generalControllerLambdaNoResult(requestParameters: GeneralApiGeneralControllerLambdaNoResultRequest, options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).generalControllerLambdaNoResult(requestParameters.rowKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiGeneralControllerLambdaProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public generalControllerLambdaProduct(requestParameters: GeneralApiGeneralControllerLambdaProductRequest, options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).generalControllerLambdaProduct(requestParameters.rowKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiGeneralControllerPrintOutProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public generalControllerPrintOutProduct(requestParameters: GeneralApiGeneralControllerPrintOutProductRequest, options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).generalControllerPrintOutProduct(requestParameters.rowKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiGeneralControllerSelectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public generalControllerSelected(requestParameters: GeneralApiGeneralControllerSelectedRequest, options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).generalControllerSelected(requestParameters.rowKey, requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralApi
     */
    public generalControllerWelcome(options?: AxiosRequestConfig) {
        return GeneralApiFp(this.configuration).generalControllerWelcome(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [rowKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerCountISOCheckProducts: async (rowKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rowKey !== undefined) {
                localVarQueryParameter['rowKey'] = rowKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [rowKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetAllISOCheckProducts: async (rowKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rowKey !== undefined) {
                localVarQueryParameter['rowKey'] = rowKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} start 
         * @param {number} end 
         * @param {string} [rowKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetSlicedISOCheckProducts: async (start: number, end: number, rowKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('productsControllerGetSlicedISOCheckProducts', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('productsControllerGetSlicedISOCheckProducts', 'end', end)
            const localVarPath = `/products/sliced/{start}/{end}`
                .replace(`{${"start"}}`, encodeURIComponent(String(start)))
                .replace(`{${"end"}}`, encodeURIComponent(String(end)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rowKey !== undefined) {
                localVarQueryParameter['rowKey'] = rowKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateHeatFlowDto} updateHeatFlowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdateHeatFlow: async (updateHeatFlowDto: UpdateHeatFlowDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateHeatFlowDto' is not null or undefined
            assertParamExists('productsControllerUpdateHeatFlow', 'updateHeatFlowDto', updateHeatFlowDto)
            const localVarPath = `/products/heat-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHeatFlowDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [rowKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerCountISOCheckProducts(rowKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerCountISOCheckProducts(rowKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [rowKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerGetAllISOCheckProducts(rowKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductsControllerGetAllISOCheckProducts200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerGetAllISOCheckProducts(rowKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} start 
         * @param {number} end 
         * @param {string} [rowKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerGetSlicedISOCheckProducts(start: number, end: number, rowKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductsControllerGetAllISOCheckProducts200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerGetSlicedISOCheckProducts(start, end, rowKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateHeatFlowDto} updateHeatFlowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerUpdateHeatFlow(updateHeatFlowDto: UpdateHeatFlowDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsControllerGetAllISOCheckProducts200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerUpdateHeatFlow(updateHeatFlowDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductsApiProductsControllerCountISOCheckProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerCountISOCheckProducts(requestParameters: ProductsApiProductsControllerCountISOCheckProductsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.productsControllerCountISOCheckProducts(requestParameters.rowKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiProductsControllerGetAllISOCheckProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetAllISOCheckProducts(requestParameters: ProductsApiProductsControllerGetAllISOCheckProductsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ProductsControllerGetAllISOCheckProducts200ResponseInner>> {
            return localVarFp.productsControllerGetAllISOCheckProducts(requestParameters.rowKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiProductsControllerGetSlicedISOCheckProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetSlicedISOCheckProducts(requestParameters: ProductsApiProductsControllerGetSlicedISOCheckProductsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ProductsControllerGetAllISOCheckProducts200ResponseInner>> {
            return localVarFp.productsControllerGetSlicedISOCheckProducts(requestParameters.start, requestParameters.end, requestParameters.rowKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductsApiProductsControllerUpdateHeatFlowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdateHeatFlow(requestParameters: ProductsApiProductsControllerUpdateHeatFlowRequest, options?: AxiosRequestConfig): AxiosPromise<ProductsControllerGetAllISOCheckProducts200ResponseInner> {
            return localVarFp.productsControllerUpdateHeatFlow(requestParameters.updateHeatFlowDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productsControllerCountISOCheckProducts operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsControllerCountISOCheckProductsRequest
 */
export interface ProductsApiProductsControllerCountISOCheckProductsRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductsApiProductsControllerCountISOCheckProducts
     */
    readonly rowKey?: string
}

/**
 * Request parameters for productsControllerGetAllISOCheckProducts operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsControllerGetAllISOCheckProductsRequest
 */
export interface ProductsApiProductsControllerGetAllISOCheckProductsRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductsApiProductsControllerGetAllISOCheckProducts
     */
    readonly rowKey?: string
}

/**
 * Request parameters for productsControllerGetSlicedISOCheckProducts operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsControllerGetSlicedISOCheckProductsRequest
 */
export interface ProductsApiProductsControllerGetSlicedISOCheckProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductsApiProductsControllerGetSlicedISOCheckProducts
     */
    readonly start: number

    /**
     * 
     * @type {number}
     * @memberof ProductsApiProductsControllerGetSlicedISOCheckProducts
     */
    readonly end: number

    /**
     * 
     * @type {string}
     * @memberof ProductsApiProductsControllerGetSlicedISOCheckProducts
     */
    readonly rowKey?: string
}

/**
 * Request parameters for productsControllerUpdateHeatFlow operation in ProductsApi.
 * @export
 * @interface ProductsApiProductsControllerUpdateHeatFlowRequest
 */
export interface ProductsApiProductsControllerUpdateHeatFlowRequest {
    /**
     * 
     * @type {UpdateHeatFlowDto}
     * @memberof ProductsApiProductsControllerUpdateHeatFlow
     */
    readonly updateHeatFlowDto: UpdateHeatFlowDto
}

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {ProductsApiProductsControllerCountISOCheckProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerCountISOCheckProducts(requestParameters: ProductsApiProductsControllerCountISOCheckProductsRequest = {}, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerCountISOCheckProducts(requestParameters.rowKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiProductsControllerGetAllISOCheckProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerGetAllISOCheckProducts(requestParameters: ProductsApiProductsControllerGetAllISOCheckProductsRequest = {}, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerGetAllISOCheckProducts(requestParameters.rowKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiProductsControllerGetSlicedISOCheckProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerGetSlicedISOCheckProducts(requestParameters: ProductsApiProductsControllerGetSlicedISOCheckProductsRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerGetSlicedISOCheckProducts(requestParameters.start, requestParameters.end, requestParameters.rowKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductsApiProductsControllerUpdateHeatFlowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerUpdateHeatFlow(requestParameters: ProductsApiProductsControllerUpdateHeatFlowRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerUpdateHeatFlow(requestParameters.updateHeatFlowDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ThresholdsApi - axios parameter creator
 * @export
 */
export const ThresholdsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdsControllerGetCatAThresholds: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/thresholds/catAThresholds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThresholdsApi - functional programming interface
 * @export
 */
export const ThresholdsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThresholdsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thresholdsControllerGetCatAThresholds(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatAThresholdDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thresholdsControllerGetCatAThresholds(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ThresholdsApi - factory interface
 * @export
 */
export const ThresholdsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThresholdsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdsControllerGetCatAThresholds(options?: AxiosRequestConfig): AxiosPromise<Array<CatAThresholdDTO>> {
            return localVarFp.thresholdsControllerGetCatAThresholds(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThresholdsApi - object-oriented interface
 * @export
 * @class ThresholdsApi
 * @extends {BaseAPI}
 */
export class ThresholdsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    public thresholdsControllerGetCatAThresholds(options?: AxiosRequestConfig) {
        return ThresholdsApiFp(this.configuration).thresholdsControllerGetCatAThresholds(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WallStructuresApi - axios parameter creator
 * @export
 */
export const WallStructuresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallStructuresControllerCountAllWallStructures: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/wallStructures/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallStructuresControllerGetAllWallStructures: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/wallStructures/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} start 
         * @param {number} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallStructuresControllerGetSlicedWallStructures: async (start: number, end: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('wallStructuresControllerGetSlicedWallStructures', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('wallStructuresControllerGetSlicedWallStructures', 'end', end)
            const localVarPath = `/wallStructures/sliced/{start}/{end}`
                .replace(`{${"start"}}`, encodeURIComponent(String(start)))
                .replace(`{${"end"}}`, encodeURIComponent(String(end)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WallStructuresApi - functional programming interface
 * @export
 */
export const WallStructuresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WallStructuresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wallStructuresControllerCountAllWallStructures(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wallStructuresControllerCountAllWallStructures(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wallStructuresControllerGetAllWallStructures(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WallStructureDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wallStructuresControllerGetAllWallStructures(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} start 
         * @param {number} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wallStructuresControllerGetSlicedWallStructures(start: number, end: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallStructureDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wallStructuresControllerGetSlicedWallStructures(start, end, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WallStructuresApi - factory interface
 * @export
 */
export const WallStructuresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WallStructuresApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallStructuresControllerCountAllWallStructures(options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.wallStructuresControllerCountAllWallStructures(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallStructuresControllerGetAllWallStructures(options?: AxiosRequestConfig): AxiosPromise<Array<WallStructureDTO>> {
            return localVarFp.wallStructuresControllerGetAllWallStructures(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WallStructuresApiWallStructuresControllerGetSlicedWallStructuresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallStructuresControllerGetSlicedWallStructures(requestParameters: WallStructuresApiWallStructuresControllerGetSlicedWallStructuresRequest, options?: AxiosRequestConfig): AxiosPromise<WallStructureDTO> {
            return localVarFp.wallStructuresControllerGetSlicedWallStructures(requestParameters.start, requestParameters.end, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for wallStructuresControllerGetSlicedWallStructures operation in WallStructuresApi.
 * @export
 * @interface WallStructuresApiWallStructuresControllerGetSlicedWallStructuresRequest
 */
export interface WallStructuresApiWallStructuresControllerGetSlicedWallStructuresRequest {
    /**
     * 
     * @type {number}
     * @memberof WallStructuresApiWallStructuresControllerGetSlicedWallStructures
     */
    readonly start: number

    /**
     * 
     * @type {number}
     * @memberof WallStructuresApiWallStructuresControllerGetSlicedWallStructures
     */
    readonly end: number
}

/**
 * WallStructuresApi - object-oriented interface
 * @export
 * @class WallStructuresApi
 * @extends {BaseAPI}
 */
export class WallStructuresApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallStructuresApi
     */
    public wallStructuresControllerCountAllWallStructures(options?: AxiosRequestConfig) {
        return WallStructuresApiFp(this.configuration).wallStructuresControllerCountAllWallStructures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallStructuresApi
     */
    public wallStructuresControllerGetAllWallStructures(options?: AxiosRequestConfig) {
        return WallStructuresApiFp(this.configuration).wallStructuresControllerGetAllWallStructures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WallStructuresApiWallStructuresControllerGetSlicedWallStructuresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallStructuresApi
     */
    public wallStructuresControllerGetSlicedWallStructures(requestParameters: WallStructuresApiWallStructuresControllerGetSlicedWallStructuresRequest, options?: AxiosRequestConfig) {
        return WallStructuresApiFp(this.configuration).wallStructuresControllerGetSlicedWallStructures(requestParameters.start, requestParameters.end, options).then((request) => request(this.axios, this.basePath));
    }
}


